import React from "react"
import { Grid } from "@material-ui/core"

import { Portlet } from "@/components"

import { AgentFormattedForList } from "@/services/AgentService"

import AgentListIdentity from "@/pages/Admin/Agent/AgentList/AgentListItem/AgentListIdentity"
import AgentListDetails from "@/pages/Admin/Agent/AgentList/AgentListItem/AgentListDetails"
import AgentListActions from "@/pages/Admin/Agent/AgentList/AgentListItem/AgentListActions"

type AgentListItemProps = {
	agent: AgentFormattedForList
	onEditAgentProfile: () => void
}

const AgentListItem: React.FC<AgentListItemProps> = (props) => {
	const { agent, onEditAgentProfile } = props

	return (
		<Portlet elevation={1}>
			<Grid container alignItems="center" spacing={2}>
				<Grid item md={3} lg={3}>
					<AgentListIdentity name={agent.name} />
				</Grid>
				<Grid item md={6} lg={7}>
					<AgentListDetails agent={agent} />
				</Grid>
				<Grid item md={3} lg={2}>
					<AgentListActions agent={agent} onEditAgentProfile={onEditAgentProfile} />
				</Grid>
			</Grid>
		</Portlet>
	)
}

export default AgentListItem
